<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Contact</strong>
      </div>

      <ContactDialog v-if="isEditable(currentPro) && userIsAdmin" />
    </template>

    <Item icon="mdi-account">{{ currentPro.contact_name }}</Item>
    <Item icon="mdi-phone">{{ currentPro.phone }} (leads)</Item>
    <Item icon="mdi-email">{{ currentPro.email }}</Item>
  </Section>
</template>

<script>
  import { Section, Item } from '@/components/pages'
  import ContactDialog from '../dialogs/Contact.vue'
  import { mapGetters } from 'vuex'
  import proMixin from '../proMixin'

  export default {
    name: 'ProContactSection',
    
    mixins: [proMixin],

    components: { Section, Item, ContactDialog },

    computed: {
      ...mapGetters ('auth', ['userIsAdmin']),
      ...mapGetters ('pros', ['currentPro']),
    },
  }
</script>